import env from "@/config/env";
import { ActionContext } from "vuex";
import {
  IBudget,
  ICouponList,
  IFilters,
  ICompetitor,
  IPagination,
  IResponseGetBudget,
  IState,
  ICoupon,
  ICouponDetails,
} from "./interfaces";

export default {
  //eslint-disable-next-line
  async getSessionUser(
    store: ActionContext<IState, any>,
    session: string
  ): Promise<boolean> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);
    //eslint-disable-next-line
    const requestOptions: any = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const url = env.base_url.concat(`index/${session}`);
    return await fetch(url, requestOptions).then(async (response) => {
      const resp = response.json();
      return resp.then((body) => {
        if (body.success) {
          store.commit("setListCompetitor", body.competitions);
          store.commit("setUserData", {
            role: body.user_role,
            session,
            rca_id: body.user_id,
          });
          return true;
        } else {
          return false;
        }
      });
    });
  },

  async loadBudget(
    //eslint-disable-next-line
    store: ActionContext<IState, any>,
    idBudget: string
  ): Promise<IResponseGetBudget> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);

    const raw = JSON.stringify({
      id: parseInt(idBudget),
      user_role: store.state.userData.role,
    });

    //eslint-disable-next-line
    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const url = env.base_url.concat("budget");
    return await fetch(url, requestOptions)
      .then(async (response) => {
        const resp = response.json();
        if (response.status >= 500) {
          store.commit("setExistCoupon", true);
          const respError: IResponseGetBudget = {
            success: false,
            couponMessage: {
              title: "Erro!",
              body: "Entre em contato com o responsável pelo site!",
            },
          };
          return respError;
        }

        return resp.then((body) => {
          if (body.success) {
            const budget = body.info;
            const inverters = {
              amount: 0,
              power: 0,
              brand: "N/A",
            };
            const panels = {
              amount: 0,
              power: 0,
              brand: "N/A",
            };
            let structures = "N/A";

            if (typeof body.budget_analise !== "undefined") {
              if (typeof body.budget_analise.inverters !== "undefined") {
                inverters.brand = "";
                //eslint-disable-next-line
                body.budget_analise.inverters.forEach((inverter: any) => {
                  inverters.amount += inverter.amount;
                  inverters.power = inverter.potency;
                  inverters.brand = inverter.name + " \n " + inverters.brand;
                });
              }
              if (typeof body.budget_analise.panels !== "undefined") {
                panels.brand = "";
                //eslint-disable-next-line
                body.budget_analise.panels.forEach((panel: any) => {
                  panels.amount += panel.amount;
                  panels.power += panel.potency;
                  panels.brand = panel.name;
                });
              }
              if (typeof body.budget_analise.structures !== "undefined") {
                //eslint-disable-next-line
                body.budget_analise.structures.forEach(
                  (structure: any, index: number) => {
                    if (index == 0) {
                      structures = "";
                    }

                    structures = structure.name + " \n " + structures;
                  }
                );
              }
            }

            const generators = {
              type: "N/A",
              brand: "N/A",
            };

            body.budget_analise.generators.forEach(
              //eslint-disable-next-line
              (generator: any, index: number) => {
                if (index == 0) {
                  generators.brand = "";
                  generators.type = "";
                }
                generators.brand =
                  generators.brand +
                  (generator.brand != ""
                    ? generator.brand +
                      (index + 1 < body.budget_analise.generators.length
                        ? ","
                        : "")
                    : "");
                if (index > 0 && generators.type != generator.type) {
                  generators.type = "Múltiplos";
                } else {
                  generators.type = generator.type;
                }
              }
            );

            store.commit("setGenerators", body.budget_analise.generators);
            //eslint-disable-next-line
            const couponsActive: any[] = [];

            if (body.coupons.length != 0) {
              //eslint-disable-next-line
              body.coupons.forEach((coupon: any, index: number) => {
                couponsActive[index] = {
                  id: coupon.rule_id,
                  name: coupon.name,
                  value: parseFloat(coupon.discount_amount),
                  use: 0,
                  maxUse: coupon.uses_per_customer - coupon.times_used,
                };
              });
            }
            const setBudget: IBudget = {
              id: budget.id,
              generators: generators,
              discountsActive: 0,
              totalDiscount: body.value_total_discount,
              value: body.value_budget,
              transferValue: body.value_transfer,
              equipamentValue: body.value_equipament,
              idIntegrator: budget.id_integrador,
              integratorName: body.integrator_name,
              fantasyIntegratorName: body.trade_name,
              reasonIntegratorName: body.trade,
              consultantName: budget.name_admin_seler,
              discountMaxBrl: body.value_max_discount,
              couponsActive: couponsActive,
              discountMaxPercent: parseFloat(
                (
                  (body.value_max_discount * 100) /
                  body.value_equipament
                ).toFixed(4)
              ),
              amountInverters: inverters.amount,
              powerInverter: inverters.power,
              brandInverter: inverters.brand,
              brandPanel: panels.brand,
              powerPanel: panels.power,
              amountPanel: panels.amount,
              powerSystem: (panels.amount * panels.power) / 1000,
              typeStructure: structures,
              deliveryLocale: body.info.city + ", " + body.info.uf,
              inGroup: body.group_ouro,
            };
            const setWebSiteId = budget.website_id;
            const codeCoupon =
              String(setBudget.id) +
              setBudget.consultantName.substr(0, 3).toUpperCase();

            if (setBudget.couponsActive.length > 0) {
              const options = setBudget.inGroup
                ? ["Ajuste de Valor"]
                : [
                    "Desconto Comercial",
                    "Bater Concorrência",
                    "Soma de descontos",
                  ];
              store.commit("setTypesCoupon", options);
            } else {
              const options2 = setBudget.inGroup
                ? ["Ajuste de Valor"]
                : ["Desconto Comercial", "Bater Concorrência"];
              store.commit("setTypesCoupon", options2);
            }
            store.commit("setCodeCoupon", codeCoupon);
            store.commit("cleanBudget");
            store.commit("setBudget", setBudget);
            store.commit("setExistCoupon", false);
            store.commit("setWebSiteId", setWebSiteId);
            const respSuccess: IResponseGetBudget = {
              success: true,
              couponMessage: {
                title: "",
                body: "",
              },
            };
            return respSuccess;
          } else {
            store.commit("setExistCoupon", true);
            const respError: IResponseGetBudget = {
              success: false,
              couponMessage: {
                title: "Erro!",
                body: "Já existe um cupom para esse orçamento!",
              },
            };
            return respError;
          }
        });
      })
      .catch(() => {
        store.commit("setExistCoupon", true);
        const respError: IResponseGetBudget = {
          success: false,
          couponMessage: {
            title: "Erro!",
            body:
              "Ocorreu um erro com o Id do orçamento! Verifique se o Id do orçamento está correto!",
          },
        };
        return respError;
      });
  },

  async storeCoupon(
    //eslint-disable-next-line
    store: ActionContext<IState, any>,
    coupon: ICoupon
  ): Promise<boolean> {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);

    const data = new FormData();
    data.append("info_generator", JSON.stringify(store.state.generators));
    data.append("coupon_name", coupon.nameCoupon);
    data.append("description", coupon.description);
    data.append("coupon_code", coupon.codeCoupon);
    data.append("coupon_discount", coupon.couponTotalValueBrl.toString());
    data.append("budget_value", coupon.budgetValue.toString());
    data.append("budget_id", store.state.budget.id);
    data.append("admin_id", store.state.userData.role.toString());
    data.append("rca_id", store.state.userData.rca_id.toString());
    data.append("integrator_id", store.state.budget.idIntegrator.toString());
    data.append("integrator_name", store.state.budget.integratorName);
    data.append("integrator_trade", store.state.budget.fantasyIntegratorName);
    data.append("payment_type", coupon.typePayment);
    data.append("coupon_type", coupon.typeCoupon);
    data.append("info_generator_type", store.state.budget.generators.type);
    const couponsUsed: { rule_id: number; qtd_used: number }[] = [];
    //eslint-disable-next-line
    store.state.budget.couponsActive.forEach((value: any, index: number) => {
      if (value.use > 0) {
        couponsUsed[index] = {
          rule_id: value.id,
          qtd_used: value.use,
        };
      }
    });

    if (couponsUsed.length > 0) {
      data.append(
        "coupons_used",
        JSON.stringify(
          couponsUsed.filter((el) => {
            return el != null;
          })
        )
      );
    }
    data.append(
      "integrator_trade_name",
      store.state.budget.reasonIntegratorName
    );
    data.append("active", coupon.validCoupon ? "true" : "false");
    data.append(
      "max_discount",
      store.state.budget.discountMaxPercent.toString()
    );
    data.append("discount_value", coupon.couponValueBrl.toString());
    data.append("discount", coupon.discountPerCent);
    data.append(
      "value_equipment",
      store.state.budget.equipamentValue.toString()
    );
    data.append("type_generator", "tri");
    data.append("brand_generator", store.state.budget.brandInverter);
    data.append("budget_sou", JSON.stringify(store.state.budget));
    if (store.state.competitor.name != "") {
      data.append(
        "competition_budget_pdf",
        store.state.competitor.pdfCompetitor
      );
      data.append("competition", JSON.stringify(store.state.competitor));
    }
    data.append("website_id", store.state.webSiteId.toString())

    //eslint-disable-next-line
    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: data,
      redirect: "follow",
    };

    const url = env.base_url.concat("generate-coupon");
    return await fetch(url, requestOptions).then(async (response) => {
      const resp = response.json();
      if (response.status >= 500) {
        return false;
      }
      return resp.then((body) => {
        if (body.success) {
          store.commit("setCodeCoupon", "Código do Cupom");
          const competitor: ICompetitor = {
            typeStructure: "",
            valueRoof: 0,
            coverDiscount: 0,
            name: "",
            brandInverter: "",
            powerInverter: "",
            amountInverter: "",
            powerPanel: "",
            brandPanel: "",
            amountPanel: "",
            powerSystem: 0,
            valueBudget: "",
            wattValue: 0,
            offer: "",
            pdfCompetitor: null,
          };
          store.commit("setCompetitor", competitor);
          return true;
        } else {
          return false;
        }
      });
    });
  },

  async loadCoupons(
    //eslint-disable-next-line
    store: ActionContext<IState, any>,
    filters: IFilters
  ): Promise<boolean> {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);

    //eslint-disable-next-line
    const requestOptions: any = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const urlFilters = `coupons/${store.state.userData.session}?find_budget_id=${filters.findBudgetId}&per_page=${store.state.paginate.per_page}&page=${store.state.paginate.page}&find_generated_id=${filters.findGeneratedId}&find_admin_id=${filters.findAdminId}&find_rule_id=${filters.findRuleId}&find_discount=${filters.findDiscount}&find_coupon_code=${filters.findCouponCode}&find_budget_min=${filters.findBudgetMin}&find_budget_max=${filters.findBudgetMax}&find_discount_min=${filters.findDiscountMin}&find_discount_max=${filters.findDiscountMax}&find_status=${filters.findStatus}&find_coupon_type=${filters.findCouponType}&find_admin_name=${filters.findAdminName}&find_admin_trade_name=${filters.findAdminTradeName}`;

    const url = env.base_url.concat(urlFilters);

    return await fetch(url, requestOptions)
      .then(async (response) => {
        const resp = response.json();
        return resp.then((body) => {
          if (body.success) {
            const paginate: IPagination = {
              page: body.page,
              per_page: body.per_page,
              total_coupons: body.total_cupons,
              total_pages: body.total_page,
            };
            body.coupons.forEach((coupon: ICouponList) => {
              coupon.dialog = false;
            });
            store.commit("setUserData", {
              role: body.user_role,
              session: store.state.userData.session,
            });
            store.commit("setPercentage", parseFloat(body.percentage));
            store.commit("setPagination", paginate);
            store.commit("setCoupons", body.coupons);
            return true;
          } else {
            return false;
          }
        });
      })
      .catch(() => {
        store.commit("setCoupons", []);
        return false;
      });
  },

  async getDetailsCoupon(
    //eslint-disable-next-line
    store: ActionContext<IState, any>,
    couponId: number
  ): Promise<ICouponDetails> {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);
    //eslint-disable-next-line
    const requestOptions: any = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const url = env.base_url.concat(`coupons/${couponId}/edit`);
    return await fetch(url, requestOptions).then(async (response) => {
      const resp = response.json();
      return resp.then((body) => {
        const budget: IBudget = JSON.parse(body.coupon.budget_sou);

        const coupon: ICouponDetails = {
          competition_budget_pdf: body.coupon.competition_budget_pdf,
          status: body.coupon.status,
          payment_type: body.coupon.payment_type,
          competitor: body.coupon.competition,
          generated_id: parseInt(body.coupon.generated_id),
          budget_id: parseInt(body.coupon.budget_id),
          budget_value: parseFloat(body.coupon.budget_value),
          discount: body.coupon.discount,
          discount_value: parseFloat(body.coupon.discount_value),
          discount_total: parseFloat(body.coupon.discount_total),
          initial_discount: parseFloat(body.coupon.initial_discount),
          coupon_code: body.coupon.coupon_code,
          admin_id: body.coupon.admin_id,
          rca_id: body.coupon.rca_id,
          rule_id: body.coupon.rule_id,
          coupon_name: body.coupon.coupon_name,
          integrator_id: body.coupon.integrator_id,
          description: body.coupon.description,
          integrator_trade: body.coupon.integrator_trade,
          integrator_trade_name: body.coupon.integrator_trade_name,
          integrator_name: body.coupon.integrator_name,
          active: body.coupon.active,
          max_discount: parseFloat(body.coupon.max_discount),
          value_equipment: parseFloat(body.coupon.value_equipment),
          budget_sou: budget,
          coupon_type: body.coupon.coupon_type,
          generator_type: body.coupon.generator_type,
          coupons_added: body.coupons_added,
        };

        if (coupon.competitor == null) {
          coupon.competitor = {
            name: "",
            brandInverter: "",
            powerInverter: "",
            amountInverter: "",
            powerPanel: "",
            brandPanel: "",
            amountPanel: "",
            powerSystem: "",
            valueBudget: "",
            wattValue: "",
            offer: "",
            pdfCompetitor: "",
            coverDiscount: "",
            valueRoof: "",
            typeStructure: "",
          };
        } else {
          coupon.competitor = JSON.parse(body.coupon.competition);
        }

        return coupon;
      });
    });
  },

  //eslint-disable-next-line
  async putCoupon(
    store: ActionContext<IState, any>,
    data: {
      couponId: number;
      value: {
        discount: number;
        discount_value: number;
        discount_total: number;
        status: string;
        active: boolean;
      };
    }
  ): Promise<boolean> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);
    const raw = JSON.stringify({
      discount: data.value.discount,
      discount_value: data.value.discount_value,
      discount_total: data.value.discount_total,
      status: data.value.status,
      active: data.value.active,
    });

    //eslint-disable-next-line
    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const url = env.base_url.concat(`coupons/${data.couponId}`);

    return await fetch(url, requestOptions).then(async (response) => {
      const resp = response.json();
      return resp.then(() => {
        return true;
      });
    });
  },

  async downloadPdf(
    store: ActionContext<IState, void>,
    path: string
  ): Promise<Blob> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${store.state.userData.session}`);

    const raw = JSON.stringify({
      path: path,
    });

    //eslint-disable-next-line
    const requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const url = env.base_url.concat("download");

    return await fetch(url, requestOptions).then((response) => {
      return response.blob();
    });
    // .catch(error => console.log('error', error));
  },
};
